import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H2 } from 'syf-component-library/ui/typography';
import { colors, fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
export const BodyContainer = styled.div `
  overflow-y: auto;
  flex: 1;

  @media ${query.greaterThanLarge} {
    max-width: 1114px;
  }
`;
export const ErrorMessageContainer = styled(Inset) `
  margin: 0;
  display: flex;
  justify-content: center;
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  max-width: 125px;
  margin: auto;
  @media ${query.lessThanSmall} {
    max-width: 115px;
  }
`;
export const CenteredContainer = styled.div `
  width: 100%;
  text-align: center;
  @media ${query.lessThanSmall} {
    width: 90%;
  }
`;
export const Title = styled(H2) `
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.medium}px;
`;
export const SubTitle = styled(Body) `
  color: ${colors.black};
  font-weight: 500;
  font-size: ${fontSizes.root}px;
`;
export const TextValueWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-basis: 75%;
  align-items: left;
  justify-content: start;
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.root}px;
  @media ${query.lessThanMedium} {
    flex-basis: 60%;
  }
`;
export const TextWrapper = styled(TextValueWrapper) `
  @media ${query.lessThanSmall} {
    flex-basis: 100%;
  }
`;
export const ModalContentWrapper = styled.div `
  display: grid;
  height: calc(100vh - 56px);
  grid-template-rows: 1fr auto;
`;
